import { useTranslation } from "@equiem/web-ng-lib";
import React from "react";
import { PriceFormat } from "../../PriceFormat";
import { SearchNode } from "./SearchEdge";
import { SearchResult } from "./SearchResult";
import { FaStore } from "react-icons/fa";

interface Props {
  product: SearchNode<"PlainProductContentEdge">;
}

export const PlainProductSearchResult: React.FC<Props> = ({ product }) => {
  const { t } = useTranslation();

  return (
    <SearchResult
      href="/store/product/[uuid]"
      as={`/store/product/${product.uuid}`}
      title={product.name}
      body={product.excerpt}
      imageUrl={product.image ?? undefined}
      footer={
        <div className="mt-auto">
          <div className="vendor-name pb-2 d-flex align-items-center">
            <FaStore /> <span className="ml-2">{product.vendor.name}</span>
          </div>
          <PriceFormat price={product.unitPrice} freeTxt={t("main.free")} />
        </div>
      }
    />
  );
};
